import {
  FilterListEntry,
  YearFilterValues,
  CategoryFilterValues
} from '../../../shared/types/filter';
import {WorkCategory} from '../../../shared/types/work';

export const emptyFilterEntry = {
  label: '',
  value: ''
};

// Constants for year filter values
export const yearFilterEntries: Array<FilterListEntry<YearFilterValues>> = [
  {
    label: `work.filter.${YearFilterValues.before1945}`,
    value: YearFilterValues.before1945
  },
  {
    label: `work.filter.${YearFilterValues.after1945}`,
    value: YearFilterValues.after1945
  }
];

export const initialYearFilterValues = yearFilterEntries;

// Constants for category filter values
export const categoryValues = {...WorkCategory};

export const categoryFilterEntries: Array<
  FilterListEntry<CategoryFilterValues>
> = [
  ...Object.values(categoryValues).map(category => ({
    label: `work.category.${category}`,
    value: category
  }))
];

export const initialCategoryFilterValues = categoryFilterEntries;
